const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

export const ProjectService = {
    async createProject(token, type, name, data) {
        const res = await fetch(`${API_BASE}/api/projects`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ type, name, data })
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to create project');
        }
        return await res.json();
    },

    async updateProject(token, projectId, updates) {
        const res = await fetch(`${API_BASE}/api/projects/${projectId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(updates)
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to update project');
        }
        return await res.json();
    },

    async getProject(token, projectId) {
        const res = await fetch(`${API_BASE}/api/projects/${projectId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to get project');
        }
        return await res.json();
    },

    async listProjects(token, limit = 50, offset = 0) {
        const res = await fetch(`${API_BASE}/api/projects?limit=${limit}&offset=${offset}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to list projects');
        }
        return await res.json();
    },

    async deleteProject(token, projectId) {
        const res = await fetch(`${API_BASE}/api/projects/${projectId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) {
            const err = await res.json();
            throw new Error(err.error || 'Failed to delete project');
        }
        return true;
    }
};
